module.exports = __webpack_public_path__ + "img/Angriffstruppmann.51cc5270.svg";